var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJohkuLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 37,
    viewBox: "0 0 115 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0H3.77126V25.8357C3.77126 27.5503 3.44332 29.0116 2.84211 30.2001C2.27733 31.2912 1.32996 32.4408 0 33.6877L3.11538 37C4.55466 35.9868 5.72065 34.9152 6.63158 33.8046C7.6336 32.4992 8.30769 31.0379 8.67206 29.3818C8.89069 28.2712 9 26.732 9 24.8031V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4998 0C30.8014 0 34.1516 1.40068 36.6097 4.18231C38.8696 6.80612 40.0193 10.2585 39.9995 14.5395C39.9995 18.7612 38.8299 22.1741 36.4908 24.798C34.0327 27.5993 30.7023 29 26.4799 29C22.2575 29 18.9272 27.619 16.5087 24.8571C14.1696 22.1939 13 18.7612 13 14.5395C13 10.2782 14.1498 6.82585 16.4295 4.18231C18.8677 1.40068 22.2377 0 26.4998 0ZM26.4998 24.7585C29.1363 24.7585 31.1384 23.6735 32.5261 21.5231C33.7353 19.6884 34.33 17.3408 34.33 14.5395C34.33 11.6592 33.7353 9.29184 32.5459 7.45714C31.1781 5.32653 29.1363 4.2415 26.4799 4.2415C23.8236 4.2415 21.8016 5.3068 20.414 7.45714C19.2642 9.31156 18.6893 11.6592 18.6893 14.5395C18.6893 17.3605 19.284 19.6884 20.4734 21.5231C21.8809 23.6735 23.8831 24.7585 26.4998 24.7585Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 0H60.3541V12.0143H47.6459V0H42V29H47.6459V16.2558H60.3541V29H66V0Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3449 15.3773C78.8019 14.7661 78.2201 14.3521 77.5995 14.1353L90.3988 0H83.5531L73.5658 11.2373V0H68V28.9803H73.5658V16.777H73.6433C74.2057 17.1319 74.8651 17.743 75.602 18.6499L84.1737 29H91L79.3449 15.3773Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115 0H109.354V18.6555C109.354 22.7223 107.23 24.7754 103 24.7754C98.7705 24.7754 96.6459 22.7223 96.6459 18.6555V0H91V18.8135C91 22.1498 92.141 24.7359 94.4623 26.5323C96.6066 28.1906 99.459 29 103 29C106.58 29 109.413 28.1906 111.538 26.5323C113.839 24.7754 115 22.1892 115 18.8135V0Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJohkuLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/johku-logo.871da25a23c5c9c35fbd50eaa6a3037a.svg";